import {
  put, takeLatest, call
} from 'redux-saga/effects'
import { treeHandlers } from 'react-hyper-tree'
import get from 'lodash/get'
import { PROJECT } from '@/constants/objectTypes'
import { successDeleteIntegration } from '@/store/actions/installation/deleteIntegration'
import request from '@/helpers/axios'
import getNewPath from '@/helpers/getNewPath'
import { DELETE_INTEGRATION } from '@/store/actions/installation'
import { generateDeleteTreeElement } from '@/constants/apiRoutes'
import createNotifications from '@/helpers/notification'
import updateNodeCount from '@/helpers/updateNodeCount'
import { setGlobalLoading } from '@/store/actions/appSettings'
import { requestGetAllConnectedIntegrations } from '@/store/actions/dictionaries/connectedIntegrations'
import { requestGetPinsAndZonesAndTelemetry } from '@/store/actions/installation/getZonesAndPinsAndTelemetry'

function* deleteIntegrationSaga({ payload }) {
  const {
    setUrlFormValues, formValues, parentId,
  } = payload
  const {
    id,
    path,
    rootId,
    FILTER,
  } = formValues
  try {
    yield put(setGlobalLoading(true))
    const tree = treeHandlers.trees['installations-tree']
    const node = tree.instance.getNodeById(id)
    const childrenCount = node.data.childrenCount
    yield request({
      url: generateDeleteTreeElement(id),
      method: 'delete',
    })
    const newPath = getNewPath(path)
    const toast = createNotifications()

    const parent = tree.instance.getNodeById(parentId)
    const parentChildren = yield call(parent.data.getChildren, parent)

    tree.handlers.setRawChildren(parent, parentChildren, 'first', true)
    updateNodeCount(tree, newPath, 'remove', childrenCount + 1)
    const selectedNodePath = get(parent, 'options.path', '')
    tree.handlers.setSelectedByPath(selectedNodePath)
    setUrlFormValues({
      id: parentId,
      rootId,
      parentTreeId: parentId,
      path: newPath,
      type: PROJECT,
      FILTER,
    })
    yield put(requestGetPinsAndZonesAndTelemetry({
      includeAll: true,
      parentTreeId: path.split('/')[2]
    }))
    yield put(setGlobalLoading(false))
    toast({
      title: 'Удаление интеграции',
      type: 'success',
      description: 'Интеграция успешно удалена.',
    })
    yield put(requestGetAllConnectedIntegrations())
    yield put(successDeleteIntegration())
  } catch (error) {
    yield put(setGlobalLoading(false))
    const toast = createNotifications()
    const errorMessage = get(error, 'response.data.errorMessage', null)
    if (errorMessage === 'Can not delete installation, because installation has attached asu') {
      toast({
        title: 'ОШИБКА ОПЕРАЦИИ!',
        type: 'error',
        description: `Невозможно удалить интеграцию!\nУдалите сначала экземпляр АСУ "${error.response.data.details.map((asu) => asu.name)}", который назначен данной интеграции`,
      })
    }
    setUrlFormValues({ FILTER })
    console.log('function*deleteIntegrationSaga -> error', error)
  }
}

export default function* root() {
  yield takeLatest(DELETE_INTEGRATION.REQUEST, deleteIntegrationSaga)
}
